import { SignalSource } from "@component-utils/signal-source"
import type { Debug } from "./types"

/**
 * Class used to track all events such as uncaught errors that happen within the application
 */
export class Timeline {
  static #items: Debug.Timeline.Item[] = []
  
  static signal = new SignalSource<{
    update: []
  }>()

  static set items (items: Debug.Timeline.Item[]) {
    this.#items = items

    this.signal.emit('update')
  }

  static get items () {
    return this.#items
  }

  static trackRequest (request: Debug.Timeline.Request) {
    this.#items.push({
      timestamp: Date.now(),
      url: window.location.href,
      type: 'request',
      request
    })

    this.signal.emit('update')
  }

  static trackError (error: Debug.Timeline.Error) {
    this.#items.push({
      timestamp: Date.now(),
      url: window.location.href,
      type: 'error',
      error
    })

    this.signal.emit('update')
  }

  static trackInteraction (interaction: Debug.Timeline.Interaction) {
    this.#items.push({
      timestamp: Date.now(),
      url: window.location.href,
      type: 'interaction',
      interaction
    })

    this.signal.emit('update')
  }
}
